import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const IrrpjAndCsllForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const { purchaseReadOnly } = useReleasePurchaseFormContext();

  return (
    <Form form={form} disabled={purchaseReadOnly}>
      <Row gutter={[12, 12]}>
        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaIrpj']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.irpjAndCsll.quotaIrpj',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueIrpj']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.irpjAndCsll.valueIrpj',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaCsll']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.irpjAndCsll.quotaCsll',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueCsll']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.irpjAndCsll.valueCsll',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default IrrpjAndCsllForm;
